import { FileType } from './FileType';
export const supportInstallationDocFileType = [
    FileType.JPEG,
    FileType.PNG,
    FileType.TIFF,
    FileType.PDF,
    FileType.ZIP,
];
